import { combineReducers } from "redux";
import { all, fork } from "redux-saga/effects";

import { emptyReducer, emptySaga } from "@multiweb/reactUtils";
import { SagaWithReturnType } from "@multiweb/types/react";
import { ReduxModuleName } from "./ReduxRegistrator";
import { ReducerInfo } from "./types";
import { getDependencyIfExists } from "./utils";

/** Vrací reducer složený ze zapojených custom reducerů */
export const getCustomReducer = () => {
    const reducerInfoArray = getDependencyIfExists<ReducerInfo[]>(ReduxModuleName.reducerInfoArray);

    if (!reducerInfoArray) {
        return emptyReducer;
    }

    return combineReducers(reducerInfoArray.reduce((acc, { name, reducer }) => ({
        ...acc,
        [name]: reducer,
    }), {}));
};

/** Vrací ságu složenou ze zapojených custom ság */
export const getCustomSaga = () => {
    const sagaArray = getDependencyIfExists<SagaWithReturnType[]>(ReduxModuleName.sagaArray);
    if (!sagaArray) {
        return emptySaga;
    }

    return function* customSaga() {
        yield all(sagaArray.map((customSaga) => fork(customSaga)));
    };
};
